// extracted by mini-css-extract-plugin
module.exports = {"fpxdemo":"FpxDemo--fpxdemo--uBdHhWA"};